module.exports = __webpack_public_path__ + "static/media/backgroundSecundary.19a5c294.png";